import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { BibliographyNodeView } from "@/components/editor/nodeviews/BibliographyNodeView";

export const BibliographyBlock = Node.create({
  name: "bibliographyBlock",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      blockId: { default: null },
      title: { default: "References" },
      style: { default: "apa" },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="bibliography-block"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": "bibliography-block" })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(BibliographyNodeView);
  },
});
